import React from 'react'
import { Avatar, Dropdown, message } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './index.module.css'

const NAV_ITEMS = [
    { path: '/chinese-seg', label: '中文分词' },
    // { path: '/english-seg', label: '英文分词' },
    { path: '/wordcloud',   label: '词云分析' },
    { path: '/sentiment',  label: '评论分析' },
    // { path: '/topic',      label: '主题分析' },
]

const CommonHeader = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('is_admin')
        navigate('/login')
    }

    const isAdmin = localStorage.getItem('is_admin') === 'true'

    const handleMenuClick = ({ key }) => {
        if (key === 'profile') {
            message.info('用户中心功能开发中')
            return
        }

        if (key === 'generate-account') {
            navigate('/generate-account')
            return
        }

        if (key === 'logout') {
            logout()
        }
    }

    const menuItems = [
        {
            key: 'profile',
            label: <span>用户中心</span>,
        },
        ...(isAdmin ? [{
            key: 'generate-account',
            label: <span>生成账户</span>,
        }] : []),
        {
            key: 'logout',
            label: <span>退出登录</span>,
        },
    ]

    const username = localStorage.getItem('username') || '用户'

    return (
        <header className={styles.header_container}>
            {/* 左侧占位，保持中间居中 */}
            <div className={styles.side_placeholder} />

            {/* 中间：logo + tabs */}
            <div className={styles.center_group}>
                <div className={styles.logo}>
                    <span className={styles.logo_shimmer}>百发百中</span>
                </div>
                <div className={styles.divider} />
                <nav className={styles.nav}>
                    {NAV_ITEMS.map(item => (
                        <div
                            key={item.path}
                            className={`${styles.nav_item} ${location.pathname === item.path ? styles.nav_item_active : ''}`}
                            onClick={() => navigate(item.path)}
                        >
                            {item.label}
                        </div>
                    ))}
                </nav>
            </div>

            {/* 右侧用户区 */}
            <div className={styles.user_area}>
                <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }}>
                    <div className={styles.user_info}>
                        <Avatar size={32} src={require('../../assets/images/user.jpg')} />
                        <span className={styles.username}>{username}</span>
                    </div>
                </Dropdown>
            </div>
        </header>
    )
}

export default CommonHeader
